// extracted by mini-css-extract-plugin
module.exports = {"container":"e_uB","up":"e_vB","down":"e_wB","percent":"e_xB","percentVal":"e_yB","title":"e_zB","tags":"e_AB","textBadge":"e_BB"};